/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Oneill_GetStateDto, OneillService } from "app/services/oneill.service";

/**
 * Resolves the "O'Neill Portal Validation State" for the Portal whose ID is in the "id" parameter
 * in the page path. 
 */
@Injectable()
export class OneillPortalValidationStateResolver implements Resolve<Oneill_GetStateDto> {

  /** Constructor */
  constructor(
    private oneillService: OneillService
  ) {}

  /** Obtains the data to be resolved in the background. */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Oneill_GetStateDto> {
    // Get the 'ID' Path parameter which is the ID of the Service to obtain...
    const id = route.paramMap.get('id');    
    if (id == null || id.length == 0) {
      return null;
    }

    // Call the API to retrieve the current state for the Portal with the given ID
    return await this.oneillService.getState(id);
  }

}
